import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export type PresenceDotTone = 'accent' | 'success' | 'night'

export interface PresenceDotProps extends BoxProps {
  tone?: PresenceDotTone
  pulse?: boolean
  size?: number
}

const toneColor: Record<PresenceDotTone, string> = {
  accent: 'var(--ds-accent-deep-b, var(--ds-accent))',
  success: 'var(--ds-success)',
  night: 'var(--ds-night-ink, var(--ds-ink))',
}

const Dot = styled(Box, {
  shouldForwardProp: (p) => p !== 'tone' && p !== 'pulse' && p !== 'size',
})<{ tone: PresenceDotTone; pulse?: boolean; size: number }>(({ tone, pulse, size }) => ({
  display: 'inline-block',
  width: size,
  height: size,
  borderRadius: '50%',
  background: toneColor[tone],
  boxShadow: `0 0 8px ${toneColor[tone]}`,
  flexShrink: 0,
  ...(pulse && { animation: 'ds-presence-pulse 1.8s ease-in-out infinite' }),
  '@keyframes ds-presence-pulse': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0.45 },
  },
}))

/** Small glowing status dot — "LIVE", "12 inside", live-presence indicators. */
export function PresenceDot({ tone = 'accent', pulse = true, size = 7, ...rest }: PresenceDotProps) {
  return <Dot tone={tone} pulse={pulse} size={size} {...rest} />
}
